module.exports = __webpack_public_path__ + "static/media/tutorial-spend-time-plus.4586c1d0.png";